var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationFooter = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

var footer_legal_1 = require("./footer-legal");

var footer_menu_1 = require("./footer-menu");

var footer_card_1 = require("./footer-card");

var footer_brand_1 = require("./footer-brand");

exports.NavigationFooter = function (props) {
  if (!Array.isArray(props.navigation) || props.navigation.length < 1) {
    return null;
  }

  return react_1.default.createElement(core_1.Wrapper, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.wrapper
    })
  }, react_1.default.createElement(footer_brand_1.FooterBrand, {
    containerStyle: props.containerStyle,
    hideBrand: props.data.hideBrand,
    logoElement: props.data.useLogoElement,
    navigation: props.navigation,
    siteHeading: props.globals.siteHeading,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.footerBrand
    })
  }), react_1.default.createElement(footer_card_1.FooterCard, {
    containerStyle: props.containerStyle,
    hideCard: props.data.hideCard,
    navigation: props.navigation,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.footerCard
    })
  }), react_1.default.createElement(footer_menu_1.FooterMenu, {
    containerStyle: props.containerStyle,
    hideMenu: props.data.hideMenu,
    hideSocial: props.data.hideSocial,
    navigation: props.navigation,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.footerMenu
    })
  }), react_1.default.createElement(footer_legal_1.FooterLegal, {
    containerStyle: props.containerStyle,
    copyright: props.data.copyright,
    hideCopyright: props.data.hideCopyright,
    hideLegal: props.data.hideLegal,
    siteMetadata: props.siteMetaData,
    supportWheelroom: props.data.supportWheelroom,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.footerLegal
    })
  }));
};